export default __webpack_public_path__ + "static/media/static-image.df19320e.png";